import React from 'react';

const CarLogo = ({ className = "", size = "lg" }) => {
  // تحديد الحجم بناءً على المعلمة size
  const sizeMap = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-24 h-24",
    "2xl": "w-32 h-32"
  };

  const sizeClass = sizeMap[size] || sizeMap.lg;

  return (
    <div className={`${sizeClass} ${className}`}>
      <svg
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        {/* الخلفية الدائرية */}
        <circle cx="256" cy="256" r="256" className="fill-current text-blue-600 opacity-10" />
        
        {/* دائرة خلفية أصغر */}
        <circle cx="256" cy="256" r="192" className="fill-current text-blue-600 opacity-20" />
        
        {/* رمز السيارة */}
        <g transform="translate(96, 156) scale(1.25)">
          {/* هيكل السيارة */}
          <path
            d="M240,128c0-6.8-1.1-13.4-3.2-19.6c-2.1-6.2-5.2-11.9-9.1-17c-3.9-5.1-8.5-9.7-13.6-13.6s-10.8-7-17-9.1 C190.8,66.5,184.2,65.4,177.3,65.4H54.7c-6.9,0-13.5,1.1-19.6,3.2s-11.9,5.2-17,9.1c-5.1,3.9-9.7,8.5-13.6,13.6 C0.6,96.4-2.5,102.1-4.6,108.3S-8,121-8,127.8L240,128z"
            className="fill-current text-blue-700"
          />
          
          {/* الزجاج الأمامي */}
          <path
            d="M190,68.8c9.5,4,17.3,10.8,22.1,19.2H74.1c4.8-8.4,12.6-15.2,22.1-19.2H190z"
            className="fill-current text-blue-500"
          />
          
          {/* المصابيح الأمامية */}
          <circle cx="25" cy="108" r="12" className="fill-current text-yellow-400" />
          <circle cx="207" cy="108" r="12" className="fill-current text-yellow-400" />
          
          {/* الإطارات */}
          <circle cx="50" cy="150" r="24" className="fill-current text-gray-800" />
          <circle cx="50" cy="150" r="12" className="fill-current text-gray-600" />
          <circle cx="182" cy="150" r="24" className="fill-current text-gray-800" />
          <circle cx="182" cy="150" r="12" className="fill-current text-gray-600" />
          
          {/* تفاصيل إضافية */}
          <rect x="70" y="100" width="92" height="6" className="fill-current text-blue-500" />
          <rect x="90" y="112" width="52" height="4" className="fill-current text-blue-500" />
        </g>
      </svg>
    </div>
  );
};

export default CarLogo;